import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { AdminService } from '../../admin.service';
import { Menu } from '../../../models/menu.model';
import { Router, ActivatedRoute, Params, Data } from '@angular/router';
import { ClientService } from '../../../services/client.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Client } from '../../../models/client.model';
import { Subscription } from 'rxjs/Subscription';
import { GroupService } from '../../../services/group.service';
import { Group } from '../../../models/group.model';
import { SubgroupService } from '../../../services/subgroup.service';
import { Subgroup } from '../../../models/subgroup.model';

declare var jQuery: any;

@Component({
  selector: 'app-client-edit',
  templateUrl: './client-edit.component.html',
  styleUrls: ['./client-edit.component.css']
})
export class ClientEditComponent implements OnInit, OnDestroy {
  loading = false;
  menus: Menu[];
  id: number;
  clientForm: FormGroup;
  client: Client;
  subscription: Subscription;
  subscriptionGroup: Subscription;
  subscriptionResponse: Subscription;

  subgroupsSubscription: Subscription;
  client_company_name = '';

  colorForm: FormGroup;

  groups: Group[];
  subgroups: Subgroup[];

  fragment;
  editMode = false;
  navigationType = 'fragment';
  navigationDefault = 'account-details';
  backUrl = '/admin/clients';

  client_account_active = 0;
  client_template_active = 0;

  @ViewChild('boxContent') boxContent: ElementRef;

  constructor(private adminService: AdminService,
              private clientService: ClientService,
              private groupService: GroupService,
              private route: ActivatedRoute,
              private router: Router,
              private subgroupService: SubgroupService
            ) {}

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        this.id = +params['id'];
        this.editMode = params['id'] != null;

        if (this.editMode) {
          this.loading = true;
          this.menus = [
            new Menu('Account', '', [
              new Menu('Account Details', 'account-details'),
              new Menu('Colors', 'colors'),
              new Menu('Logo',  'logo'),
              new Menu('Hi-Res Logo', 'hires_logo')
            ]),
            new Menu('Group', '', [
              new Menu('Group Details', 'group-details')
            ])
          ];

          this.clientService.httpGetClient(this.id);
        } else {
          this.menus = [
            new Menu('Account', '', [
              new Menu('Account Details', 'account-details')
            ])
          ];
        }
      }
    );

    this.adminService.loadMenu(this.menus);

    this.adminService.routeData.next({
      'route': this.route,
      default: this.navigationDefault,
      type: this.navigationType
    });

    this.route.fragment.subscribe(
      (frag: string) => {
        const boxContentChild = this.boxContent.nativeElement.children;

        for ( const boxChild of boxContentChild ) {
          if (boxChild.id === frag || (!frag && boxChild.id === this.navigationDefault)) {
            boxChild.className = 'edit-box';
          } else {
            boxChild.className = 'edit-box hidden';
          }
        }
      }
    );

    this.groupService.httpGetGroups();
    this.subgroupService.httpGetSubgroups();

    this.subscription = this.clientService.clientChanged.subscribe(
      (client: Client) => {
        this.client = client;

        if ( this.editMode && typeof client !== 'undefined' ) {
          this.loading = false;

          this.client_account_active = client.is_account_active;
          this.client_template_active = client.is_template_active;

          this.initFormEdit();
          this.initColorFormEdit();
          this.initColorPickerEdit();
        }
      }
    );

    this.subscriptionGroup = this.groupService.groupsChanged.subscribe(
      (groups: Group[]) => {
        this.groups = groups;
      }
    );

    this.subgroupsSubscription = this.subgroupService.subgroupGetAll.subscribe(
      (subgroups: any) => {
        if ( typeof subgroups !== 'undefined' && subgroups.status === 'success' ) {
          this.subgroups = subgroups.data;
        }
      }
    );

    this.subscriptionResponse = this.clientService.clientOperation.subscribe(
      (client: Client) => {
        if ( typeof client.ID !== 'undefined'  ) {
          this.loading = false;

          this.router.navigate([this.backUrl], {relativeTo: this.route});
        }
      }
    );

    this.initForm();
    this.initColorForm();
    this.initColorPicker();

    this.imageReader();
  }

  imageReader() {
    function readURL(input) {

      if (input.files && input.files[0]) {
          const reader = new FileReader();
          reader.onload = function (e) {
            const target: any = e.target;
            const content: string = target.result;

            const image_placement = jQuery(input).attr('data-action');
            jQuery(image_placement).attr('src', content);
          };
          reader.readAsDataURL(input.files[0]);
      }
    }

    jQuery('#image-primary').change(function(){
      readURL(this);
    });

    jQuery('#image-secondary').change(function(){
      readURL(this);
    });

    jQuery('#image-hires-primary').change(function(){
      console.log(this);
      readURL(this);
    });

    jQuery('#image-hires-secondary').change(function(){
      readURL(this);
    });
  }

  initColorPicker() {
    jQuery('.asColorpicker1').asColorPicker();
    jQuery('.asColorpicker2').asColorPicker();
    jQuery('.asColorpicker3').asColorPicker();
    jQuery('.asColorpicker4').asColorPicker();
    jQuery('.asColorpicker5').asColorPicker();
    jQuery('.asColorpicker6').asColorPicker();
    jQuery('.asColorpicker7').asColorPicker();
    jQuery('.asColorpicker8').asColorPicker();
  }

  initColorPickerEdit() {
    jQuery('.asColorpicker1').asColorPicker('val', this.client.color_1);
    jQuery('.asColorpicker2').asColorPicker('val', this.client.color_2);
    jQuery('.asColorpicker3').asColorPicker('val', this.client.color_3);
    jQuery('.asColorpicker4').asColorPicker('val', this.client.color_4);
    jQuery('.asColorpicker5').asColorPicker('val', this.client.color_5);
    jQuery('.asColorpicker6').asColorPicker('val', this.client.color_6);
    jQuery('.asColorpicker7').asColorPicker('val', this.client.color_7);
    jQuery('.asColorpicker8').asColorPicker('val', this.client.color_8);
  }

  private initForm() {
    this.clientForm = new FormGroup({
      'group_id': new FormControl('', Validators.required),
      'subgroup_id': new FormControl(0),
      'office_id': new FormControl('', Validators.required),
      'franchise_name': new FormControl(''),
      'franchise_code': new FormControl(''),
      'is_franchise_master': new FormControl(0),
      'is_account_master': new FormControl(0),
      'company_name': new FormControl('', Validators.required),
      'name': new FormControl('', Validators.required),
      'street': new FormControl('', Validators.required),
      'suburb': new FormControl('', Validators.required),
      'state': new FormControl('', Validators.required),
      'state_abbr': new FormControl(''),
      'postcode': new FormControl('', Validators.required),
      'country': new FormControl('', Validators.required),
      'phone': new FormControl('', Validators.required),
      'fax': new FormControl(''),
      'email': new FormControl('', Validators.required),
      'is_local_search': new FormControl(0, Validators.required)
    });
  }

  private initColorForm() {
    this.colorForm = new FormGroup({
      'color_1': new FormControl(),
      'color_2': new FormControl(),
      'color_3': new FormControl(),
      'color_4': new FormControl(),
      'color_5': new FormControl(),
      'color_6': new FormControl(),
      'color_7': new FormControl(),
      'color_8': new FormControl()
    });
  }

  private initColorFormEdit() {
    this.colorForm.patchValue({
      'color_1': this.client.color_1,
      'color_2': this.client.color_2,
      'color_3': this.client.color_3,
      'color_4': this.client.color_4,
      'color_5': this.client.color_5,
      'color_6': this.client.color_6,
      'color_7': this.client.color_7,
      'color_8': this.client.color_8
    });
  }

  private initFormEdit() {
    this.client_company_name = this.client.company_name;
    this.clientForm.patchValue({
      'group_id': this.client.group_id,
      'subgroup_id': this.client.subgroup_id,
      'office_id': this.client.office_id,
      'franchise_name': this.client.franchise_name,
      'franchise_code': this.client.franchise_code,
      'is_franchise_master': this.client.is_franchise_master,
      'is_account_master': this.client.is_account_master,
      'company_name': this.client.company_name,
      'name': this.client.name,
      'street': this.client.street,
      'suburb': this.client.suburb,
      'state': this.client.state,
      'state_abbr': this.client.state_abbr,
      'postcode': this.client.postcode,
      'country': this.client.country,
      'phone': this.client.phone,
      'fax': this.client.fax,
      'email': this.client.email,
      'is_local_search': this.client.is_local_search
    });
  }

  onSubmit() {
    const clientValues = this.clientForm.value;
    this.loading = true;
    if ( this.editMode) {
      this.clientService.httpPutClient(this.id, clientValues);
    } else {
      clientValues['is_account_active'] = 1;
      clientValues['is_template_active'] = 1;
      this.clientService.httpPostClient(clientValues);
    }

  }

  onReset() {
    const clientValues = this.clientForm.value;
    clientValues['version'] = 0;

    this.clientService.httpPutClient(this.id, clientValues);
  }

  onAccountActive() {
    const clientValues = this.clientForm.value;
    clientValues['is_account_active'] = (this.client.is_account_active === 1) ? 0 : 1;

    this.clientService.httpPutClient(this.id, clientValues);
  }

  onTemplateActive() {
    const clientValues = this.clientForm.value;
    clientValues['is_template_active'] = (this.client.is_account_active === 1) ? 0 : 1;

    this.clientService.httpPutClient(this.id, clientValues);
  }

  saveColor() {
    this.colorForm.patchValue({
      'color_1': jQuery('.asColorpicker1').val(),
      'color_2': jQuery('.asColorpicker2').val(),
      'color_3': jQuery('.asColorpicker3').val(),
      'color_4': jQuery('.asColorpicker4').val(),
      'color_5': jQuery('.asColorpicker5').val(),
      'color_6': jQuery('.asColorpicker6').val(),
      'color_7': jQuery('.asColorpicker7').val(),
      'color_8': jQuery('.asColorpicker8').val()
    });

    const colorFormValue = this.colorForm.value;

    this.clientService.httpPutClient(this.id, colorFormValue);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionGroup.unsubscribe();
    this.subscriptionResponse.unsubscribe();
  }

  uploadLogo(event: Event, type) {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    for (let i = 0; i < target.files.length; i++) {
      this.clientService.httpPutLogo(this.id, type, target.files[i]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/clients/client-edit/client-edit.component.ts